import { gql } from '@apollo/client';

const GET_PLAN_RECOMMENDATIONS = gql`
  query(
    $userId: String!
    $zipCode: String!
    $planType: String!
    $ignoreNetworkCoverage: Boolean!
    $includeHMOInSearch: Boolean
    $partnerId: String
    $wizardType: PlanRecommendationContext
    $effectiveDate: String
    $bypassCurrentPlan: Boolean
  ) {
    getPlanRecommendations(
      userId: $userId
      includeHMOInSearch: $includeHMOInSearch
      zipCode: $zipCode
      planType: $planType
      ignoreNetworkCoverage: $ignoreNetworkCoverage
      partnerId: $partnerId
      wizardType: $wizardType
      effectiveDate: $effectiveDate
      bypassCurrentPlan: $bypassCurrentPlan
    ) {
      recommendations {
        id
        name
        savings
      }
      countyFIPS
      currentPlanRanking
      currentPlanDetails {
        allProvidersInNetwork
        cmsId
        drugsNotCovered {
          LabelName
        }
      }
      user {
        providers {
          id
          first_name
          last_name
          organization_name
          provider_role
          lapro_active
        }
        pharmacies {
          id
          name
          lapro_active
          address_line_one
          city
          state
        }
        prescriptions {
          id
          label_name
          lapro_active
        }
      }
      inNetworkCoverage {
        providers {
          id
          inNetworkPercentage
          inNetworkCount
          lastName
          planCount
        }
        prescriptions {
          id
          inNetworkPercentage
          inNetworkCount
          labelName
          planCount
          isGeneric
        }
      }
    }
  }
`;

export default GET_PLAN_RECOMMENDATIONS;
